import API from '../api/Api';

export const backEndAccessToken = (state) => state[API.user._key][API.user.accessToken];
// export const backEndAccessToken = (state) => state[API.oidc._key][API.oidc.user._key] === null ? "No accessToken" : state[API.oidc._key][API.oidc.user._key][API.oidc.user.accessToken];